export const QuickSetupSkeleton = () => {
  return (
    <div className="flex justify-center bg-neutral-surface-gray px-4 py-4 md:px-0">
      <div className="w-full max-w-[705px]">
        {/* Header skeleton */}
        <div className="mb-6 text-center">
          <div className="mb-1 flex justify-center">
            <div className="h-8 w-48 animate-pulse rounded-lg bg-gray-200 md:w-64"></div>
          </div>
          <div className="flex justify-center">
            <div className="h-5 w-full max-w-[320px] animate-pulse rounded-lg bg-gray-200 md:max-w-[480px]"></div>
          </div>
        </div>

        {/* Panel skeletons matching SetupPanel structure */}
        <div className="flex flex-col gap-5">
          {[1, 2, 3, 4, 5, 6, 7].map((index) => (
            <div key={index} className="w-full rounded-lg border border-neutral-mid-gray bg-white px-3 py-4 md:px-5 md:py-6">
              {/* Panel header */}
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3 md:gap-4">
                  {/* Step number */}
                  <div className="h-6 w-6 animate-pulse self-start rounded-full bg-gray-200 md:h-8 md:w-8"></div>
                  {/* Title and description */}
                  <div className="flex-1">
                    <div className="mb-2 h-5 w-32 animate-pulse rounded bg-gray-200 md:h-6 md:w-40"></div>
                    <div className="h-4 w-40 animate-pulse rounded bg-gray-200 md:w-64"></div>
                  </div>
                </div>
                {/* Expand icon and progress */}
                <div className="flex items-center gap-2 md:gap-3">
                  <div className="h-4 w-8 animate-pulse rounded bg-gray-200 md:w-12"></div>
                  <div className="h-4 w-4 animate-pulse rounded bg-gray-200 md:h-5 md:w-5"></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
